import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Icons, MUI, Typography } from '@styles';

const PasswordCheck = (props) => {
  const {
    capitalLettersV,
    lengthV,
    lettersV,
    numbersV,
    symbolsV,
    isChangePassword
  } = props;

  return (
    <>
      <MUI.Box marginBottom="16px">
        {!isChangePassword ? (
          <Typography.H5>{i18n.t('ChangePass.configProcess')}</Typography.H5>
        ) : (
          <Typography.H5>{i18n.t('ChangePass.enterNewPass')}</Typography.H5>
        )}
      </MUI.Box>

      <MUI.Box margin="16px 0px">
        <Typography.Text>{i18n.t('ChangePass.passMustMeet')}</Typography.Text>
      </MUI.Box>

      <Styled.BoxRule>
        {lengthV ? <Styled.BoxCheckIcon><Icons.Check /></Styled.BoxCheckIcon> : <Styled.BoxCircleIcon><Icons.Circle /></Styled.BoxCircleIcon>}
        <Typography.Text>{i18n.t('ChangePass.mustHaveMin8Chars')}</Typography.Text>
      </Styled.BoxRule>

      <Styled.BoxRule>
        {symbolsV ? <Styled.BoxCheckIcon><Icons.Check /></Styled.BoxCheckIcon> : <Styled.BoxCircleIcon><Icons.Circle /></Styled.BoxCircleIcon>}
        <MUI.Box width="90%">
          <Typography.Text>{i18n.t('ChangePass.mustHaveSymDot')}</Typography.Text>
        </MUI.Box>
      </Styled.BoxRule>

      <Styled.BoxRule>
        {capitalLettersV && lettersV ? <Styled.BoxCheckIcon><Icons.Check /></Styled.BoxCheckIcon> : <Styled.BoxCircleIcon><Icons.Circle /></Styled.BoxCircleIcon>}
        <Typography.Text>{i18n.t('ChangePass.atLeastCap')}</Typography.Text>
      </Styled.BoxRule>

      <Styled.BoxRule>
        {numbersV ? <Styled.BoxCheckIcon><Icons.Check /></Styled.BoxCheckIcon> : <Styled.BoxCircleIcon><Icons.Circle /></Styled.BoxCircleIcon>}
        <Typography.Text>{i18n.t('ChangePass.mustBetweenDigit0')}</Typography.Text>
      </Styled.BoxRule>
    </>
  );
};

PasswordCheck.propTypes = {
  // Validación de letras mayúsculas.
  capitalLettersV: PropTypes.bool.isRequired,
  // Validación de longuitud de constraseña.
  lengthV: PropTypes.bool.isRequired,
  // Validación de letras minúsculas.
  lettersV: PropTypes.bool.isRequired,
  // Validación de números.
  numbersV: PropTypes.bool.isRequired,
  // Validación de símbolos.
  symbolsV: PropTypes.bool.isRequired,
  // Boolean que indica si se está cambiando la contraseña.
  isChangePassword: PropTypes.bool.isRequired
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.BoxRule = styled.div`
  display: flex;
  align-items: center;
  margin: 16px 0;
`;

Styled.BoxIcon = styled.div`
  margin-right: 16px;
  // width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Styled.BoxCheckIcon = styled(Styled.BoxIcon)`
  .MuiSvgIcon-root {
    font-size: 20px;
    color: ${(props) => props.theme.colors.green};
  }
`;

Styled.BoxCircleIcon = styled(Styled.BoxIcon)`
  .MuiSvgIcon-root {
    font-size: 14px;
  }
`;


export default PasswordCheck;